import { API_BASE_URL } from './config.js';
import fetchWrapper from '../components/utility/fetchWrapper.js'

export const dashboardData = {
  getDashboardData: async (clientId) => {
    try {
      const response = await fetchWrapper(`${API_BASE_URL}/api/v1/aws/dashboard/${clientId}`);
      if (!response.ok) {
        throw new Error('Failed to fetchWrapper dashboard data');
      }
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetchWrappering dashboard data:', error);
      throw error;
    }
  },

  getAllAccountsDashboardData: async () => {
    try {
      const response = await fetchWrapper(`${API_BASE_URL}/api/v1/aws/dashboard`);
      if (!response.ok) {
        throw new Error('Failed to fetch all accounts dashboard data');
      }
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching all accounts dashboard data:', error);
      throw error;
    }
  },
};